module.exports = __webpack_public_path__ + "static/media/26.ccf94750.JPG";